import React, { useEffect } from "react";
import "./Blogs_Page.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendar } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import Common_Banner from "../common/common-banner/Common_Banner";
import { useDispatch, useSelector } from "react-redux";

import { AllBlogs } from "../../features/admin/common/Slice";
import { IDS } from "../../utils/IDS";

const Blogs_Page = () => {
  const navigate = useNavigate();
  const handleBlogClick = (blog) => {
    navigate(`/blog/${blog.id}`, { state: blog });
  };
  // const blogData = [
  //   {
  //     id: 1,
  //     image: "/assets/images/home/Our_Blogs/img-1.png",
  //     category: "Data Engineering",
  //     title: "The Role of Data Engineering in Digital Transformation",
  //     date: "January 28, 2026",
  //     desc:
  //       "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout...",
  //   },

  //   {
  //     id: 2,
  //     image: "/assets/images/home/Our_Blogs/img-2.png",
  //     category: "Data Engineering",
  //     title: "The Role of Data Engineering in Digital Transformation",
  //     date: "January 28, 2026",
  //     desc:
  //       "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout...",
  //   },

  //   {
  //     id: 3,
  //     image: "/assets/images/home/Our_Blogs/img-3.png",
  //     category: "Data Engineering",
  //     title: "The Role of Data Engineering in Digital Transformation",
  //     date: "January 28, 2026",
  //     desc:
  //       "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout...",
  //   },
  //   {
  //     id: 4,
  //     image: "/assets/images/home/Our_Blogs/img-1.png",
  //     category: "Data Engineering",
  //     title: "The Role of Data Engineering in Digital Transformation",
  //     date: "January 28, 2026",
  //     desc:
  //       "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout...",
  //   },

  //   {
  //     id: 5,
  //     image: "/assets/images/home/Our_Blogs/img-2.png",
  //     category: "Data Engineering",
  //     title: "The Role of Data Engineering in Digital Transformation",
  //     date: "January 28, 2026",
  //     desc:
  //       "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout...",
  //   },

  //   {
  //     id: 6,
  //     image: "/assets/images/home/Our_Blogs/img-3.png",
  //     category: "Data Engineering",
  //     title: "The Role of Data Engineering in Digital Transformation",
  //     date: "January 28, 2026",
  //     desc:
  //       "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout...",
  //   },
  //   {
  //     id: 7,
  //     image: "/assets/images/home/Our_Blogs/img-1.png",
  //     category: "Data Engineering",
  //     title: "The Role of Data Engineering in Digital Transformation",
  //     date: "January 28, 2026",
  //     desc:
  //       "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout...",
  //   },

  //   {
  //     id: 8,
  //     image: "/assets/images/home/Our_Blogs/img-2.png",
  //     category: "Data Engineering",
  //     title: "The Role of Data Engineering in Digital Transformation",
  //     date: "January 28, 2026",
  //     desc:
  //       "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout...",
  //   },

  //   {
  //     id: 9,
  //     image: "/assets/images/home/Our_Blogs/img-3.png",
  //     category: "Data Engineering",
  //     title: "The Role of Data Engineering in Digital Transformation",
  //     date: "January 28, 2026",
  //     desc:
  //       "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout...",
  //   },
  // ];

  const dispatch = useDispatch();

  const blogs = useSelector((state) => state?.common?.all_blogs);

  useEffect(() => {
    dispatch(AllBlogs());
  }, [dispatch]);

  return (
    <section className="Blogs_Page Our_Blogs">
      <Common_Banner title="Blogs" />

      <div className="container">
        <div className="blog_section">
          <div className="row">
            {blogs?.map((post) => (
              <div
                className="col-lg-4 col-md-6 col-sm-6 col-12 mb-4"
                key={post.id}
              >
                <div
                  className="blog_card card"
                  onClick={() => handleBlogClick(post)}
                >
                  <div className="card-body p-0">
                    <div className="blog_img_div">
                      <img
                        src={`${IDS.IMG_URL}${post.image}`}
                        alt={post.heading}
                        className="blog_img"
                      />
                    </div>

                    <div className="category_title">
                      <h5 className="post_title">{post.heading}</h5>
                      <p className="post_date">
                        <span>
                          <FontAwesomeIcon
                            icon={faCalendar}
                            style={{ color: "#BFBFBF" }}
                          />
                        </span>{" "}
                        {new Date(post.created_at).toDateString()}
                      </p>
                    </div>

                    {/* <p
                      className="post_desc"
                      dangerouslySetInnerHTML={{
                        __html: post.description.slice(0, 120) + "...",
                      }}
                    /> */}



                  </div>
                  <div className="card-footer p-0">
                    <div className="read_more_div">
                      <button className="read_more_btn">Read More</button>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Blogs_Page;
